import axios from "axios";

//Устанавливаем window.config в public/config.js
const config = window.config || {};

const headers = {
  "Content-Type": "application/json",
};

if (process.env.NODE_ENV === "production") {
  headers["Cache-Control"] = "no-cache";
  headers["Pragma"] = "no-cache";
  headers["Expires"] = "0";
  headers["X-App-Build"] = BUILD_VERSION;
}

const axiosConfig = {
  withCredentials: true,
  headers,
};

if (config) {
  axiosConfig.baseURL = config.baseURL;
  if (config.headers) {
    Object.entries(config.headers).forEach(([key, value]) => {
      axiosConfig.headers[key] = value;
    });
  }
}

const server = axios.create(axiosConfig);

server.interceptors.request.use(
  function(options) {
    if (process.env.NODE_ENV === "production" && window.amlTechAcsId) {
      options.headers.amlTechAcsId = window.amlTechAcsId;
    }

    if (!options.dontLog) {
      console.log("Запрос: ", options);
    }

    return options;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// выносим обработчик ошибок в store, чтобы диспатчить алерты
export function addErrorHandler(resolve = (r) => r, reject = (e) => Promise.reject(e)) {
  server.interceptors.response.use(resolve, reject);
}

export function removeErrorHandler(handler) {
  server.interceptors.response.eject(handler);
}

export default server;
